/* eslint-disable no-unused-vars */
import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import apis from '@/apis';

import {
  SYNTHESE,
  SYNTHESE_IZZYPILOT,
  TRESORERIE_IZZYPILOT,
  TRESORERIE,
  RECETTES_DEPENSES,
  POINTS_SENSIBLES,
  SUIVI_BUDGETAIRE,
  PREVISIONNEL,
  OPERATIONS,
  SUIVI_TVA,
  RELEVES_BANCAIRES,
  MES_DEPOTS,
  MES_DOCUMENTS,
  MES_DEVIS_FACTURES,
  AIDE,
  COMPTE,
  EMPRUNTS,
  MODULE_TABLEAU_DE_BORD,
  MODULE_OPERATIONS,
  MODULE_COFFRE_FORT,
  MARKETPLACE,
  EULA,
} from '../Constants/MenusConstants';

import store from '../Store';

Vue.use(VueRouter);

function getUserConnected() {
  return new Promise(((resolve, reject) => {
    if (store.getters.userConnected === null) {
      axios.get('/api/user').then(({ data: user }) => {
        if (user !== '') {
          store.commit('SET_USER_CONNECTED', user);
          resolve(user);
        }
        reject();
      }).catch(() => {
        reject();
      });
    } else {
      resolve(store.getters.userConnected);
    }
  }));
}

function getFirstMenuVisible(menus, modulesVisible) {
  for (let i = 0; i < menus.length; i += 1) {
    const menu = menus[i];
    if (modulesVisible.includes(menu.id)) {
      return menu;
    }
  }
  return null;
}

function checkIfModuleIsVisibleForUser(menuToCheck, otherMenusNext) {
  return async function checkModuleAndNotOrRedirect(to, from, next) {
    try {
      const { modulesVisible } = await apis.User.getModulesAccessibility();
      if (modulesVisible.includes(menuToCheck.id)) {
        next();
      } else {
        const menuToRedirect = getFirstMenuVisible(otherMenusNext, modulesVisible);
        if (menuToRedirect !== null) {
          next({
            name: menuToRedirect.name,
          });
        }
        // throw new Error(`L 'utilisateur n' a pas accès au module ${menuToCheck.name}`);
      }
    } catch (error) {
      next(error);
    }
  };
}

function checkIfFileExistsInStore(from, to, next) {
  if (store.state.importedFile !== null) {
    next();
  } else {
    next('/');
  }
}

const router = new VueRouter({
  mode: 'history',
  base: 'pwa',
  routes: [
    {
      path: '/',
      // component: import(/* PwaIndex */ '@/modules/pwa/App.vue'),
      redirect: { name: OPERATIONS.name },
    },
    {
      path: '/module-tableau-de-bord',
      component: () => import(/* DashboardIndex */ '@/modules/pwa/Pages/Dashboard/DashboardIndex.vue'),
      name: 'Page-TableauDeBord',
      redirect: { name: SYNTHESE.name },
      meta: {
        order: 1,
      },
      children: [
        {
          path: 'synthese',
          name: SYNTHESE.name,
          beforeEnter: checkIfModuleIsVisibleForUser(SYNTHESE, MODULE_TABLEAU_DE_BORD),
          component: () => import(/* TabSynthese */ '@/modules/pwa/Pages/Dashboard/TabSynthese.vue'),
          meta: {
            order: 1,
            title: 'Synthèse - Tableau de bord - iZzy',
          },
        },
        {
          path: 'synthese-izzypilot',
          name: SYNTHESE_IZZYPILOT.name,
          beforeEnter: checkIfModuleIsVisibleForUser(SYNTHESE_IZZYPILOT, MODULE_TABLEAU_DE_BORD),
          component: () => import(/* TabSyntheseIzzyPilot */ '@/modules/pwa/Pages/Dashboard/TabSyntheseIzzyPilot.vue'),
          meta: {
            order: 1,
            title: 'Synthèse - Tableau de bord - iZzy',
          },
        },
        {
          path: 'tresorerie-izzypilot',
          name: TRESORERIE_IZZYPILOT.name,
          beforeEnter: checkIfModuleIsVisibleForUser(TRESORERIE_IZZYPILOT, MODULE_TABLEAU_DE_BORD),
          component: () => import(/* TabTresorerieIzzyPilot */ '@/modules/pwa/Pages/Dashboard/TabTresorerieIzzyPilot.vue'),
          meta: {
            order: 1,
            title: 'trésorerie - Tableau de bord - iZzy',
          },
        },
        {
          path: 'tresorerie',
          name: TRESORERIE.name,
          beforeEnter: checkIfModuleIsVisibleForUser(TRESORERIE, MODULE_TABLEAU_DE_BORD),
          component: () => import(/* TabTresorerie */ '@/modules/pwa/Pages/Dashboard/TabTresorerie.vue'),
          meta: {
            order: 2,
            title: 'Trésorerie - Tableau de bord - iZzy',
          },
        },
        {
          path: 'recettes-depenses',
          name: RECETTES_DEPENSES.name,
          beforeEnter: checkIfModuleIsVisibleForUser(RECETTES_DEPENSES, MODULE_TABLEAU_DE_BORD),
          component: () => import(/* TabRecettesDepenses */ '@/modules/pwa/Pages/Dashboard/TabRecettesDepenses.vue'),
          meta: {
            order: 3,
            title: 'Recettes / Dépenses - Tableau de bord - iZzy',
          },
        },
        {
          path: 'points-sensibles',
          name: POINTS_SENSIBLES.name,
          beforeEnter: checkIfModuleIsVisibleForUser(POINTS_SENSIBLES, MODULE_TABLEAU_DE_BORD),
          component: () => import(/* TabPointsSensibles */ '@/modules/pwa/Pages/Dashboard/TabPointsSensibles.vue'),
          meta: {
            order: 3,
            title: 'Points sensibles - Tableau de bord - iZzy',
          },
        },
        {
          path: 'suivi-budgetaire',
          name: SUIVI_BUDGETAIRE.name,
          beforeEnter: checkIfModuleIsVisibleForUser(SUIVI_BUDGETAIRE, MODULE_TABLEAU_DE_BORD),
          component: () => import(/* TabSuiviBudgetaire */ '@/modules/pwa/Pages/Dashboard/TabSuiviBudgetaire.vue'),
          meta: {
            order: 3,
            title: 'Suivi budgétaire - Tableau de bord - iZzy',
          },
        },
        {
          path: 'previsionnel',
          name: PREVISIONNEL.name,
          beforeEnter: checkIfModuleIsVisibleForUser(PREVISIONNEL, MODULE_TABLEAU_DE_BORD),
          component: () => import(/* TabPrevisionnel */ '@/modules/pwa/Pages/Dashboard/TabPrevisionnel.vue'),
          meta: {
            order: 3,
            title: 'Prévisionnel - Tableau de bord - iZzy',
          },
        },
      ],
    },
    {
      path: '/module-operations',
      component: () => import(/* Operations */'@/modules/pwa/Pages/Operations/OperationsIndex.vue'),
      name: 'Page-Operations',
      redirect: { name: OPERATIONS.name },
      meta: {
        order: 2,
      },
      // La navigation suivante est complexe, alors voici un petit schéma
      // url = pwa/module-operations/operations
      // <TabOperations>
      //     <OperationsToProcessFilters />
      //     <OperationItem v-for />
      //     <router-view>
      //         url = pwa/module-operations/operations/:id
      //         <OperationDetail>
      //             <OperationDetailTva />
      //             <router-view>
      //                 url = pwa/module-operations/operations/:id/affecter
      //                 <OperationDetailAffectation>
      //                     <OperationDetailSummary/>
      //                     <Affectation/>
      //                         <SuggestionsTab />
      //                         <NaturesTab>
      //                             <router-view>
      //                                  url = pwa/module-operations/operations/:id/affecter/:natureId
      //                                 <NatureComptes/>
      //                             </router-view>
      //                         </NaturesTab>
      //                     </Affectation>
      //                 </OperationDetailAffectation>
      //                 url = pwa/module-operations/operations/:id/affecter
      //                 <OperationDetailDecoupage />
      //
      //             </router-view>
      //         </OperationDetail>
      //     </router-view>
      // </TabOperations>
      children: [
        {
          path: 'operations',
          name: OPERATIONS.name,
          component: () => import(/* TabOperations */'@/modules/pwa/Pages/Operations/TabOperations.vue'),
          beforeEnter: checkIfModuleIsVisibleForUser(OPERATIONS, MODULE_OPERATIONS),
          meta: {
            // Obligé de reprendre l'ordre du parent à cause du redirect
            // Si vous trouvez mieux, je suis preneur
            order: 3,
            title: 'Opérations - iZzy',
          },
          children: [
            {
              path: ':id',
              name: 'Operation-Detail',
              component: () => import(/* OperationDetail */'@/modules/pwa/Pages/Operations/TabOperations/OperationDetail.vue'),
              props: (route) => ({
                initialPcgModelSelected: route.params.initialPcgModelSelected,
              }),
              meta: {
                title: 'Détail d\'une opération - Opération - iZzy',
              },
              children: [
                {
                  path: 'affecter',
                  name: 'Operation-Affectation',
                  // TODO WHY IS THIS BEING INJECTED INTO THE OperationDetailAffectation COMPONENT WHEN IT DOESN'T EVEN APPEAR TO BE USED?
                  // TODO IF SO THIS DATA BLOCK COULD BE REMOVED.
                  data() {
                    return {
                      dateOperation: this.transaction.DateEcriture,
                    };
                  },
                  meta: {
                    title: 'Affecter une opération - Opération - iZzy',
                  },
                  component: () => import(/* OperationDetailAffectation */'@/modules/pwa/Pages/Operations/TabOperations/OperationDetailAffectation.vue'),
                },
                {
                  path: 'decouper',
                  name: 'Operation-Decoupage',
                  meta: {
                    title: 'Découper une opération - Opérations - iZzy',
                  },
                  component: () => import(/* OperationDetailDecoupage */'@/modules/pwa/Pages/Operations/TabOperations/OperationDetailDecoupage.vue'),
                  props: (route) => ({
                    transaction: route.params.transaction,
                  }),
                },
                {
                  path: 'desaffecter',
                  meta: {
                    title: 'Désaffecter une opération - Opérations - iZzy',
                  },
                  name: 'Operation-Desaffectation',
                  component: () => import(/* OperationDeleteAffectation */'@/modules/pwa/Pages/Operations/TabOperations/OperationDeleteAffectation.vue'),
                },
                {
                  path: 'historique',
                  name: 'Operation-Historique',
                  meta: {
                    title: "Historique de l'opération - Opérations - iZzy",
                  },
                  component: () => import(/* OperationDetailHistory */'@/modules/pwa/Pages/Operations/TabOperations/OperationDetailHistory.vue'),
                },
                {
                  path: 'suggestion-files',
                  name: 'Operation-Suggestion-Fichiers',
                  meta: {
                    title: 'Suggestion de fichiers - Opérations - iZzy',
                  },
                  component: () => import(/* OperationDetailSuggestionsFiles */'@/modules/pwa/Pages/Operations/TabOperations/OperationDetailSuggestionFiles.vue'),
                  props: (route) => ({
                    transaction: route.params.transaction,
                  }),
                },
                {
                  path: 'sous-operation/:idFille',
                  name: 'Operation-Sous-Operation',
                  meta: {
                    title: 'Liste des sous-opérations - Opérations - iZzy',
                  },
                  component: () => import(/* OperationDetailSousOperation */'@/modules/pwa/Pages/Operations/TabOperations/OperationDetailSousOperation.vue'),
                },
                {
                  path: 'affectation-multiligne',
                  name: 'Operation-Affectation-Multiligne',
                  meta: {
                    title: 'Affectation multiligne - Opérations - iZzy',
                  },
                  props: (route) => ({
                    originalTransaction: route.params.originalTransaction,
                    nature: route.params.nature,
                    similarTransactions: route.params.operationsSimilaires,
                  }),
                  component: () => import(/* AffectationMultiligne */'@/modules/pwa/Pages/Operations/TabOperations/AffectationMultiligne.vue'),
                },
              ],
            },
            {
              path: '/module-operations/operations/recherche-avancee',
              name: 'Advanced-Search',
              meta: {
                title: 'Filtrer mes opérations - Opérations - iZzy',
              },
              component: () => import(/* AdvancedSearch */'@/modules/pwa/Pages/Operations/TabOperations/AdvancedSearch.vue'),
            },
          ],
        },
        {
          path: 'suivi-tva',
          name: SUIVI_TVA.name,
          beforeEnter: checkIfModuleIsVisibleForUser(SUIVI_TVA, MODULE_OPERATIONS),
          component: () => import(/* SuiviTva */'@/modules/pwa/Pages/Operations/TabSuiviTva.vue'),
          meta: {
            order: 4,
            title: 'Suivi de TVA - iZzy',
          },
          children: [
            {
              path: '/module-operations/suivi-tva/recherche-avancee',
              name: 'Suivi-Tva-Advanced-Search',
              component: () => import(/* SuiviTvaAdvancedSearch */'@/modules/pwa/Pages/Operations/TabSuiviTva/AdvancedSearch.vue'),
            },
          ],
        },
        {
          path: 'releves-bancaires',
          name: RELEVES_BANCAIRES.name,
          beforeEnter: checkIfModuleIsVisibleForUser(RELEVES_BANCAIRES, MODULE_OPERATIONS),
          component: () => import(/* ReleveBancaires */'@/modules/pwa/Pages/Operations/TabRelevesBancaires.vue'),
          meta: {
            order: 5,
            title: 'Relevés bancaires - iZzy',
          },
          children: [
            {
              path: '/module-operations/releves-bancaires/recherche-avancee',
              name: 'Releves-Bancaires-Advanced-Search',
              component: () => import(/* ReleveBancairesAdvancedSearch */'@/modules/pwa/Pages/Operations/TabRelevesBancaires/AdvancedSearch.vue'),
            },
          ],
        },
        {
          path: 'emprunts',
          name: EMPRUNTS.name,
          beforeEnter: checkIfModuleIsVisibleForUser(EMPRUNTS, MODULE_OPERATIONS),
          component: () => import(/* Emprunts */'@/modules/pwa/Pages/Emprunts/TabEmprunts.vue'),
          props: (route) => ({
            ribId: route.params.ribId,
          }),
          meta: {
            order: 6,
            title: 'Emprunts - iZzy',
          },
        },
        {
          path: 'create-edit-emprunt',
          name: 'Create-Edit-Emprunt',
          meta: {
            title: 'Création et édition d\'un tableau d\'emprunt - Opérations - iZzy',
          },
          props: (route) => ({
            isMultiaffectable: route.params.isMultiaffectable,
            multiaffectationParams: route.params.multiaffectationParams,
            exitRoute: route.params.exitRoute,
          }),
          component: () => import(/* CreateEditEmprunt */'@/modules/pwa/Pages/Operations/TabOperations/CreateEditEmprunt.vue'),
        },
      ],
    },
    {
      path: '/coffre-fort',
      component: () => import(/* CoffreFort */ '@/modules/pwa/Pages/CoffreFort/CoffreFortIndex.vue'),
      name: 'Page-CoffreFort',
      redirect: { name: MES_DEPOTS.name },
      meta: {
        order: 3,
      },
      children: [
        {
          path: 'mes-depots',
          name: MES_DEPOTS.name,
          meta: {
            title: 'Mes dépots - iZzy',
          },
          component: () => import(/* MesDepots */'@/modules/pwa/Pages/CoffreFort/MesDepots.vue'),
          beforeEnter: checkIfModuleIsVisibleForUser(MES_DEPOTS, MODULE_COFFRE_FORT),
        },
        // {
        //   path: 'mes-documents',
        //   name: MES_DOCUMENTS.name,
        //   component: () => import(/* MesDocuments */'@/modules/pwa/Pages/CoffreFort/MesDocuments.vue'),
        //   beforeEnter: checkIfModuleIsVisibleForUser(SUIVI_BUDGETAIRE, MODULE_COFFRE_FORT),
        // },
      ],
    },
    {
      path: '/devis-facture',
      component: () => import(/* Devis Facture */ '@/modules/pwa/Pages/Gestion/DevisFacture.vue'),
      name: MES_DEVIS_FACTURES.name,
    },
    {
      path: '/eula',
      component: () => import(/* Eula */'@/modules/pwa/Pages/Eula/Eula.vue'),
      name: EULA.name,
    },
    {
      path: '/module-marketplace',
      component: () => import(/* Marketplace */ '@/modules/pwa/Pages/Marketplace/MarketplaceIndex.vue'),
      name: 'Page-Marketplace',
      redirect: { name: MARKETPLACE.name },
      meta: {
        order: 4,
      },
      children: [
        {
          path: '/module-marketplace/marketplace',
          name: MARKETPLACE.name,
          meta: {
            title: 'Marketplace - iZzy',
          },
          component: () => import(/* TabMarketplace */'@/modules/pwa/Pages/Marketplace/TabMarketplace.vue'),
        },
        {
          path: '/module-marketplace/show-partner/:id',
          name: 'Show-Partner-Pwa',
          meta: {
            title: 'Marketplace - iZzy',
          },
          component: () => import(/* TabMarketplace */'@/modules/pwa/Pages/Marketplace/DetailPartner.vue'),
        },
      ],
    },
    {
      path: '/aide',
      component: () => import(/* Aide */'@/modules/pwa/Pages/Aide/Aide.vue'),
      name: AIDE.name,
      meta: {
        order: 4,
      },
    },
    {
      path: '/compte',
      component: () => import(/* Compte */'@/modules/pwa/Pages/Profile/Profile.vue'),
      name: COMPTE.name,
      meta: {
        order: 5,
        title: 'Compte - iZzy',
      },
    },
    {
      path: '/login-pwa',
      name: 'login',
      meta: {
        title: 'Page de connexion - iZzy',
      },
      component: () => import(/* Login */'@/modules/pwa/Pages/Login/Login.vue'),
      beforeEnter(to, from, next) {
        getUserConnected().then(() => {
          next('/');
        }).catch(() => {
          next();
        });
      },
    },
    {
      path: '/photo',
      component: () => import(/* ImportDocument */'@/modules/pwa/Pages/ImportDocument/ImportDocumentIndex.vue'),
      name: 'import-document',
      beforeEnter: checkIfFileExistsInStore,
      meta: {
        title: 'Importation du document - iZzy',
      },
      children: [
        {
          path: '/import-document/ajuster',
          name: 'Import-Document-Ajuster',
          component: () => import(/* ImportDocumentEdit */'@/modules/pwa/Pages/ImportDocument/ImportDocumentEdit.vue'),
          beforeEnter: checkIfFileExistsInStore,
        },
        {
          path: '/import-document/détails-du-document',
          name: 'Import-Document-formulaire',
          component: () => import(/* ImportDocumentFormulaire */'@/modules/pwa/Pages/ImportDocument/ImportDocumentFormulaire.vue'),
          beforeEnter: checkIfFileExistsInStore,
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }

  if (to.name === 'login') {
    next();
  }
  getUserConnected()
    .then(() => {
      next();
    }).catch(() => {
      if (to.path !== '/login-pwa') {
        next({ name: 'login' });
      }
    });
});

export default router;
